export const useValidation = config => {
  const validate = payload =>
  // @ts-expect-error TS(2769) FIXME: No overload matches this call.
  config.reduce((acc, {
    name,
    valid
  }) => {
    const current = payload.find(({
      field
    }) => field === name);
    if (current) {
      const isValid = valid(current.value);
      if (!isValid) {
        return [...acc, {
          name
        }];
      }
    }
    return acc;
  }, []);
  return {
    // @ts-expect-error TS(2322) FIXME: Type '(payload: Payload[]) => Config' is not assig... Remove this comment to see the full error message
    validate
  };
};